export default class Validate {
  static email(value) {
    return value && !!value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  }

  static required(value) {
    return value !== undefined && value !== null && value !== '';
  }

  static onlyNumbers(value) {
    return value && !!value.match(/^\d+$/);
  }

  static onlyLetters(value) {
    return value && !!value.match(/[a-zA-Záãâäàéêëèíîïìóõôöòúûüùçñ]+/);
  }

  static noSpaces(value) {
    return value && !!value.match(/^\S+$/);
  }

  static minLength(value, min = 0) {
    return value && !!(value.length >= min);
  }

  static maxLength(value, max = 0) {
    return value && !!(value.length <= max);
  }

  static dateFormat(value) {
    return value && !!value.match(/^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/);
  }

  static minDate() {

  }

  static maxDate() {

  }
}
